import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLoja } from './LojaContext';
import { Card } from '../../components/ui/card';
import { Package } from 'lucide-react';

const statusColors = {
  pending_payment: { bg: 'bg-amber-500/15', text: 'text-amber-400', label: 'Aguardando pagamento' },
  paid: { bg: 'bg-sky-500/15', text: 'text-sky-400', label: 'Pago' },
  delivered: { bg: 'bg-emerald-500/15', text: 'text-emerald-400', label: 'Entregue' },
  cancelled: { bg: 'bg-red-500/15', text: 'text-red-400', label: 'Cancelado' },
};

export default function LojaOrders() {
  const { API, authHeaders } = useLoja();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/orders`, { headers: authHeaders() })
      .then(r => setOrders(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [API]);

  if (loading) return <div className="text-center py-16 text-slate-400">Carregando...</div>;
  if (orders.length === 0) return (
    <div className="text-center py-16">
      <Package className="w-16 h-16 text-slate-600 mx-auto mb-3" />
      <p className="text-slate-400">Você ainda não tem pedidos</p>
    </div>
  );

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Meus Pedidos</h1>
      <div className="space-y-3">
        {orders.map(o => {
          const st = statusColors[o.status] || { bg: 'bg-slate-500/15', text: 'text-slate-400', label: o.status };
          return (
            <Card key={o.id} className="bg-slate-900 border-slate-800 p-4">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <div className="text-xs text-slate-400">Pedido #{o.id.substring(0, 8)}</div>
                  <div className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString('pt-BR')}</div>
                </div>
                <span className={`px-2 py-1 rounded text-xs font-medium ${st.bg} ${st.text}`}>{st.label}</span>
              </div>
              <div className="space-y-1 my-3">
                {o.items.map((it, idx) => (
                  <div key={idx} className="text-sm text-slate-300">{it.product_name} <span className="text-slate-500">x{it.quantity}</span></div>
                ))}
              </div>
              <div className="flex justify-between border-t border-slate-800 pt-2 mt-2">
                <span className="text-slate-400 text-sm">Total</span>
                <span className="font-bold text-fuchsia-400">R$ {o.total.toFixed(2)}</span>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
